import React, { useState, useRef, useEffect, forwardRef } from 'react';
import ReactToPrint from 'react-to-print';
import HttpService from '../services/httpService';
import {
  TextField, Checkbox, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, RadioGroup, Radio, FormControlLabel
} from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import { getApprovedProjects } from '../redux/actions/financeAction';
import decorpotLogo from '../assets/img/org/deco_new_logo.png'
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Barcode from 'react-barcode';

const useStyles = makeStyles((theme) => ({
  printContainer: {
    '@media print': {
      pageBreakBefore: 'always',
      pageBreakAfter: 'always',
    },
  },
  printPage: {
    pageBreakAfter: 'always',
    marginBottom: '20px',
    textAlign: "center",
  },
  projectDetails: {
    textAlign: 'center', // Center text
    fontWeight: '700',
    fontSize: '1rem',
    marginTop:"-20px",
    marginBottom:"20px"
  },
  barcodeContainer: {
    textAlign: 'center',
    heigth : '4rem',
    marginTop:"-20px"
  },
  barcode: {
    width: '20rem', // Set desired width for the barcode
    margin: '0 auto' // Center barcode horizontally
  },
  table: {
    borderCollapse: 'collapse',
    marginLeft: '1rem',
    marginRight: '1rem',
    width: 'auto',
  },
  tableCell: {
    border: '1px solid #d3d3d3', // slaty/light grey color
    padding: '8px',
    textAlign  : 'center',
  },
  barcodeWrapper: {
    width: '20rem', // Set desired width for the barcode wrapper
    margin: '0 auto', // Center barcode horizontally
    display: 'flex', // Use flexbox to center the barcode
    justifyContent: 'center' // Center the barcode inside the wrapper
  },
  buttonContainer: {
    display: 'flex',
    gap: '10px',
    margin: '20px 0',
  },
  activeButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark, // Darken the color on hover, or use the same color to prevent transparency
    },
  },
  inactiveButton: {
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.grey[700], // Darken the color on hover, or use the same color to prevent transparency
    },
  },
  
}));


const GenerateBarcode = (props) => {
  const classes = useStyles();
  const { approvedProjects } = useSelector(state => state.finance);
  const [storeMaterials, setStoreMaterials] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [activeFilter, setActiveFilter] = useState('inactive');
  const [barcodeData, setBarcodeData] = useState([]);
  const [toogleGenerateBarcode,setToggleGenerateBarcode] = useState(false)
  const [projectDetails, setProjectDetails] = useState([]);
  const [filterOption, setFilterOption] = useState('notPrinted');
  const [barcodeInput, setBarcodeInput] = useState('');
  const [showBarcodeGenerated,setShowBarcodeGenerated] = useState(false)

  const printContentRef = useRef();
  const reactToPrintRef = useRef();
  const inputRef = useRef(null);

  const handleBarcodeInput = (event) => {
    if (event.key === 'Enter') {
      setBarcodeInput(''); // Clear input for the next scan
    } else if (event?.key?.length === 1) {
      setBarcodeInput(prevInput => prevInput + event.key);
    }
  };
  
  useEffect(() => {
    inputRef.current?.focus();
    document.addEventListener('keydown', handleBarcodeInput);
  
    return () => document.removeEventListener('keydown', handleBarcodeInput);
  }, []);

  useEffect(() => {
    getApprovedProjects()
    // eslint-disable-next-line
  }, [])

  const getApprovedProjects = async () => {
    try {
      props.setLoading(true)
      await props.getApprovedProjects()
    }catch(error){
      props.setSnackInfo("Something went wrong","error")
    }
  }

  const handleSelect = async (event, newValue) => {
    try {
      let res = await HttpService.getBomProjectDetails({ id: newValue?._id });
      const patternsWithCheckbox = res.data.patterns.map(pattern => ({
        ...pattern,
        checked: true
      }));

      setStoreMaterials(patternsWithCheckbox);
      setProjectDetails(res.data.project);
      setSelectAll(patternsWithCheckbox.every(pattern => pattern.checked));
    } catch (error) {
      props.setSnackInfo("Something went wrong","error")
    }
  };

  const handleCheckboxChange = (data) => {
    const updatedPatterns = storeMaterials.map((pattern) =>
      pattern._id === data ? { ...pattern, checked: !pattern.checked } : pattern
    );
    setStoreMaterials(updatedPatterns);
    setSelectAll(updatedPatterns.every(pattern => pattern.checked));
  };

  const handleCheckboxChangeForActive = (data) => {
    const updatedPatterns = storeMaterials.map((pattern) =>
      pattern._id === data ? { ...pattern, checked: !pattern.checked } : pattern
    );
    setStoreMaterials(updatedPatterns);
    setSelectAll(updatedPatterns.every(pattern => pattern.checked));
  };

  const handleSelectAll = () => {
    const newState = !selectAll;
    const updatedPatterns = storeMaterials.map(pattern => ({
      ...pattern,
      checked: newState
    }));
    setStoreMaterials(updatedPatterns);
    setSelectAll(newState);
  };

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    setFilterOption('notPrinted')
  };

  const handleGenerateBarcodes = async () => {
    const selectedPatternIds = storeMaterials
      .filter(pattern => pattern.checked && (activeFilter === 'inactive' ? pattern.isActive === false : pattern.isActive === true))
      .map(pattern => pattern._id);

      if(selectedPatternIds.length  === 0){
        props.setSnackInfo("Please Select Checkbox to Generate Barcode",'warning');
        return
      }
      setShowBarcodeGenerated(true)

    try {
      await HttpService.updateBarcodeGeneration({ patterns: selectedPatternIds });
      handleSelect('',projectDetails)
      // props.setSnackInfo({ message: 'Barcodes generated successfully', severity: 'success' });
    } catch (error) {
      props.setSnackInfo("Failed to Generate Barcode",'error');
    }
  };

  const handlePrintBarcodes = async() => {
    const selectedPatterns = storeMaterials.filter(pattern => {
      // Common condition: pattern must be checked and active
      const isCommonMatch = pattern.checked && pattern.isActive === true;
    
      // Additional condition based on filterOption
      if (filterOption === "notPrinted") {
        return isCommonMatch && (!pattern.isBarcodePrinted || pattern.isBarcodePrinted !== true);
      } else {
        return isCommonMatch && pattern.isBarcodePrinted === true;
      }
    });
      const selectedPatternIds = selectedPatterns.map(pattern => pattern._id);
     props.setLoading(true)
      try {
        await HttpService.updatedisPatternPrint({ patterns: selectedPatternIds });
        handleSelect('',projectDetails)
        
      }catch(error){
        props.setSnackInfo("Something went wrong","error")
      }
      props.setLoading(false)

      if(selectedPatterns.length === 0){
        props.setSnackInfo("Please Check line items to Print","warning");
        return;
      }
  
  
    const formattedBarcodeData = selectedPatterns.map(pattern => ({
      code: `${pattern?._id}`,
      projectDetails : `${projectDetails['code']}-${projectDetails['clientName']}`,
      displayCode: `${projectDetails['code']}`,
      description: pattern.description || 'No description',
      scopeName: pattern.scopeId?.name || 'N/A',
      laminateName : pattern.materialId?.name || 'N/A', 
      laminateCode : pattern.materialId?.code || 'N/A', 
      pattern: pattern.start || 'N/A',
      plyType: pattern.laminateType || 'N/A',
      laminateType: pattern.plyType || 'N/A',
      unitType: pattern.unitType?.name || 'N/A',
      quantity: 1
    }));
  
    setBarcodeData(formattedBarcodeData);
  
    setTimeout(() => {
      if (reactToPrintRef.current) {
        reactToPrintRef.current.handlePrint();
      }
    }, 200);
  };
  
  const PrintContent = forwardRef((props, ref) => (
    <div ref={ref} className={classes.printContainer}>
 <div>
      {barcodeData.length > 0 ? (
        barcodeData.map((data, index) => (
          <div key={index} className={classes.printPage}>
            {/* Project Details */}
            <div style={{marginTop:"1rem"}}> <img src={decorpotLogo} style={{width:"15rem",heigth:"7rem"}}/></div>
            <div className={classes.barcodeContainer}>
              <Barcode value={data.code} displayValue={false} className={classes.barcode} />
            </div>

            <div className={classes.projectDetails}>
              {data.projectDetails}
            </div>
            <div style={{ margin: '0 20px' }}> 
            <Table>
              <TableBody style={{ border: "1px solid grey" }}>
                <TableRow>
                  <TableCell style={{ border: "1px solid grey" }}>Scope Name:</TableCell>
                  <TableCell style={{ border: "1px solid grey" }}>{data.scopeName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ border: "1px solid grey" }}>PLY <b style={{fontWeight:'900'}}>/</b> BOARD TYPE:</TableCell>
                  <TableCell style={{ border: "1px solid grey" }}>{data?.laminateType}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ border: "1px solid grey" }}>Laminate Code:</TableCell>
                  <TableCell style={{ border: "1px solid grey" }}>{data.laminateCode}</TableCell>
                </TableRow>
               
                <TableRow>
                  <TableCell style={{ border: "1px solid grey" }}>LAMINATE <b style={{ fontWeight: 900, fontSize: '17px', lineHeight: '1' }}>- </b> OSL <b style={{ fontWeight: 900, fontSize: '16px', lineHeight: '1' }}>/</b> BSL:</TableCell>
                  <TableCell style={{ border: "1px solid grey" }}>{data?.plyType}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ border: "1px solid grey" }}>Pattern No:</TableCell>
                  <TableCell style={{ border: "1px solid grey" }}>{data.pattern}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ border: "1px solid grey" }}>Unit Type:</TableCell>
                  <TableCell style={{ border: "1px solid grey" }}>{data.unitType}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ border: "1px solid grey" }}>Quantity:</TableCell>
                  <TableCell style={{ border: "1px solid grey" }}>{data.quantity}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            </div>
          </div>
        ))
      ) : (
        <p>No barcode data available</p>
      )}
    </div>
    </div>
  ));
  

  const handleFilterOptionChange = (event) => {
    setFilterOption(event.target.value);
  };

  const filteredMaterials = storeMaterials.filter(pattern => {
    // Check active or inactive based on activeFilter
    const isActiveMatch = activeFilter === 'inactive' ? !pattern.isActive : pattern.isActive;
    
    // Filter based on filterOption for printing status
    const isBarcodePrintedMatch = filterOption === 'all'
      ? true
      : filterOption === 'notPrinted'
      ? !pattern.isBarcodePrinted
      : pattern.isBarcodePrinted;
  
    return isActiveMatch && isBarcodePrintedMatch;
  });
  return (
    <div>
      <Autocomplete
        onChange={handleSelect}
        id="bom"
        options={approvedProjects}
        getOptionLabel={(option) => option.searchName || ''}
        style={{ width: 500 }}
        renderInput={(params) => <TextField {...params} label="Search Project" variant="outlined" />}
      />
      {storeMaterials.length > 0 && (
        <div className={classes.buttonContainer}>
        <Button
          className={activeFilter === 'inactive' ? classes.activeButton : classes.inactiveButton}
          onClick={() => handleFilterChange('inactive')}
        >
          Barcode Not Generated
        </Button>
        <Button
          className={activeFilter === 'active' ? classes.activeButton : classes.inactiveButton}
          onClick={() => handleFilterChange('active')}
        >
          Barcode Generated
        </Button>
        </div>
      )}
 {storeMaterials.length > 0 && (
  <>
        {activeFilter === 'inactive' ? (
        <div>
          <Button
            variant="contained"
            color="primary"
            className={classes.generateButton}
            onClick={handleGenerateBarcodes}
  
          >
            Generate Barcode
          </Button>
        </div>
      ) : (
        <div>

          <Button
            variant="contained"
            color="secondary"
            className={classes.generateButton}
            onClick={handlePrintBarcodes}
          >
            Print All Barcodes
          </Button>
          <div style={{ display: "none" }}>
            <ReactToPrint
              trigger={() => <Button style={{ display: 'none' }}>Print</Button>}
              content={() => printContentRef.current}
              ref={reactToPrintRef}
              onAfterPrint={() => console.log('Print job completed')}
            />
          </div>
      <RadioGroup
        row
        value={filterOption}
        onChange={handleFilterOptionChange}
      >
         <FormControlLabel
          value="notPrinted"
          control={<Radio color="primary" />}
          label="Not Printed"
        />
        <FormControlLabel
          value="printed"
          control={<Radio color="primary" />}
          label="Printed"
        />
       
      </RadioGroup>
        </div>
      )}
      </>
    )}
     {storeMaterials.length > 0 && (
      <>
      <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
        <Table aria-label="knowledge details table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAll}
                  color="primary"
                />
                Select All
              </TableCell>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Sl.No</TableCell>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Space Name</TableCell>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Scope Name</TableCell>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Sub Category</TableCell>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Material Name</TableCell>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Unit Type</TableCell>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>PLY <b style={{fontWeight:'900'}}>/</b> BOARD TYPE</TableCell>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>LAMINATE - OSL / BSL</TableCell>
              <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Pattern No</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {filteredMaterials.map((el, index) => (
              <TableRow key={index}>
                <TableCell className={classes.tableCell}>
                  {
                    activeFilter === 'inactive' ?
                      <Checkbox
                        checked={el.checked}
                        onChange={() => handleCheckboxChange(el._id)}
                        color="primary"
                      />
                      :
                      <Checkbox
                        checked={el.checked}
                        onChange={() => handleCheckboxChangeForActive(el._id)}
                        color="primary"
                      />
                  }
                </TableCell>
                <TableCell className={classes.tableCell}>{index + 1}</TableCell>
                <TableCell className={classes.tableCell}>{el.spaceNameId.name}</TableCell>
                <TableCell className={classes.tableCell}>{el.scopeId.name}</TableCell>
                <TableCell className={classes.tableCell}>{el.subCategoryId.name}</TableCell>
                <TableCell className={classes.tableCell}>{el.materialId.name}</TableCell>
                <TableCell className={classes.tableCell}>{el.unitType.name}</TableCell>
                <TableCell className={classes.tableCell}>{el?.plyType || 'NA'}</TableCell>
                <TableCell className={classes.tableCell}>{el?.laminateType || 'NA'}</TableCell>
                <TableCell className={classes.tableCell}>{el.start}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </>
     )}
      <div style={{ display: "none" }}>
        <PrintContent ref={printContentRef} />
      </div>

      <Dialog
  open={showBarcodeGenerated}
  fullWidth
  // maxWidth={"md"}
  aria-labelledby="alert-dialog-slide-title"
  aria-describedby="alert-dialog-slide-description"
>
  <DialogContent style={{ padding: "2rem", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
    <h3>Barcode Generated Successfully</h3>
    <h3>Go to Barcode Generated Button to Print Barcode</h3>
    <Button variant="contained" color="primary" onClick={()=>setShowBarcodeGenerated(false)}>Close</Button>
  </DialogContent>
</Dialog>

    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo, getApprovedProjects })(GenerateBarcode);